import { Layout as SeeUILayout } from '@see-ui/core';
import React from 'react';
import AppFooter from '../AppFooter';
import AppHeader from '../AppHeader';

interface LayoutProps {
  title?: string;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ title, children }) => {
  return (
    <SeeUILayout>
      {<AppHeader />}
      {/* <PageHeader>
        <div className="flex flex-row flex-wrap justify-between items-center py-4">
          <Title as="h2" className="text-white py-4">
            {title}
          </Title>
          <div className="w-full max-w-sm py-4"></div>
        </div>
      </PageHeader> */}
      {children}
      <AppFooter />
    </SeeUILayout>
  );
};

export default Layout;
